<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="flex justify-between items-center w-full">
				<span class="el-dialog__title break-normal">{{ $t("DetailContract") }}</span>
				<BasicContextMenu class="mr-2" :target="targetContextMenu" @onClickEdit="data => $emit('onClickEdit', { ...data, employee: this.employee })" />
			</div>
			<div>
				<el-collapse v-if="contract" v-model="activeGeneral" class="cbs-collapse mt-0">
					<el-collapse-item name="GeneralInfo">
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">{{ $t("ActiveContract") }}</h6>
						</template>
						<div class="p-6 pb-0" v-if="contract">
							<div>
								<vs-row class="mb-1">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("FullName") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.employee.name }}</vs-col>
								</vs-row>
								<vs-row class="mb-1">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("ContractType") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.contracttype.name }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.code">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("ContractCode") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.code }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.start_date">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("StartDate") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.start_date | dateTime(userDateTimeFormat) }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.end_date">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("EndDate") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.end_date | dateTime(userDateTimeFormat) }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.department">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("Department") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.department.name }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.title">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("Title") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ contract.title.name }}</vs-col>
								</vs-row>
								<vs-row class="mb-1" v-if="contract.salary">
									<vs-col vs-w="4">
										<label class="text-solid-gray-1 text-base">{{ $t("Salary") }}:</label>
									</vs-col>
									<vs-col vs-w="8" class="text-black text-base">{{ $helper.numFormat(contract.salary) }}</vs-col>
								</vs-row>
							</div>
						</div>
					</el-collapse-item>
				</el-collapse>

				<!-- History -->

				<!-- Logs -->
				<el-collapse id="contract-history-with-loading" class="vs-con-loading__container cbs-collapse">
					<el-collapse-item>
						<template slot="title">
							<h6 class="uppercase font-bold ml-6">{{ $t("HistoryContract") }}</h6>
						</template>
						<h6 v-if="logsContracts.length === 0" class="text-center px-6 py-3">{{ $t("Notify.NoDataAvailable") }}</h6>
						<div v-else class="px-3">
							<vs-table ref="table" class="stack-table" :sst="true" :data="logsContracts" :noDataText="$t('Notify.NoDataAvailable')">
								<template slot="thead">
									<vs-th class="no-sorter">
										<h6 class="font-medium uppercase">{{ $t("ContractCode") }}</h6>
									</vs-th>
									<vs-th sort-key="deaddate">
										<h6 class="font-medium uppercase">{{ $t("ContractType") }}</h6>
									</vs-th>
									<vs-th sort-key="overdays" class="custom-sort-filter">
										<h6 class="font-medium uppercase">{{ $t("StartDate") }}</h6>
									</vs-th>
								</template>

								<template slot-scope="{ data }">
									<tbody>
										<vs-tr class="cursor-pointer" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
											<vs-td :data-header="$t('ContractCode')">
												<p class="text-base text-base w-full text-left">{{ tr.code }}</p>
											</vs-td>

											<vs-td :data-header="$t('ContractType')">
												<p class="w-full">{{ tr.contracttype.name }}</p>
											</vs-td>
											<vs-td :data-header="$t('StartDate')">
												<p class="text-base">{{ tr.start_date | dateTime("DD/MM/YYYY") }}</p>
											</vs-td>
											<template class="expand-user" slot="expand">
												<div class="con-expand-users w-full">
													<vs-row class="mb-1" v-if="tr.start_date">
														<vs-col vs-w="4">
															<label class="text-solid-gray-1 text-base">{{ $t("StartDate") }}:</label>
														</vs-col>
														<vs-col vs-w="8" class="text-black text-base">{{ tr.start_date | dateTime(userDateTimeFormat) }}</vs-col>
													</vs-row>
													<vs-row class="mb-1" v-if="tr.end_date">
														<vs-col vs-w="4">
															<label class="text-solid-gray-1 text-base">{{ $t("EndDate") }}:</label>
														</vs-col>
														<vs-col vs-w="8" class="text-black text-base">{{ tr.end_date | dateTime(userDateTimeFormat) }}</vs-col>
													</vs-row>
													<vs-row class="mb-1" v-if="tr.department">
														<vs-col vs-w="4">
															<label class="text-solid-gray-1 text-base">{{ $t("Department") }}:</label>
														</vs-col>
														<vs-col vs-w="8" class="text-black text-base">{{ tr.department.name }}</vs-col>
													</vs-row>
													<vs-row class="mb-1" v-if="tr.title">
														<vs-col vs-w="4">
															<label class="text-solid-gray-1 text-base">{{ $t("Title") }}:</label>
														</vs-col>
														<vs-col vs-w="8" class="text-black text-base">{{ tr.title.name }}</vs-col>
													</vs-row>
													<vs-row class="mb-1" v-if="tr.salary">
														<vs-col vs-w="4">
															<label class="text-solid-gray-1 text-base">{{ $t("Salary") }}:</label>
														</vs-col>
														<vs-col vs-w="8" class="text-black text-base">{{ $helper.numFormat(tr.salary) }}</vs-col>
													</vs-row>
												</div>
											</template>
										</vs-tr>
									</tbody>
								</template>
							</vs-table>
						</div>
					</el-collapse-item>
				</el-collapse>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import BasicContextMenu from "@/components/basic-context-menu/BasicContextMenu";
import { contractPermissions, getUserPermissions } from "@/mixins/mixins.js";
import * as _ from "lodash";
export default {
	name: "EmployeeContractDetailDialog",
	mixins: [getUserPermissions({ ...contractPermissions })],

	components: { BasicContextMenu },
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		employee: {
			type: Object,
			default: () => {}
		},
		contracts: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			activeGeneral: ["GeneralInfo"]
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		contract() {
			const tes = _.find(this.contracts, { status: this.$constant.CONTRACT_STATUS.ACTIVE });
			console.log("Active ", tes);
			return _.find(this.contracts, { status: this.$constant.CONTRACT_STATUS.ACTIVE });
		},
		targetContextMenu() {
			return { ...this.contract, can_edit: this.mixinIsCanViewAllContract && this.contract };
		},
		logsContracts() {
			return _.remove(this.contracts, n => {
				return n.status !== this.$constant.CONTRACT_STATUS.ACTIVE;
			});
		}
	},
	watch: {},
	methods: {},
	created() {}
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
#contract-history-with-loading .td-check {
	display: none;
}
</style>
